module.exports = "/static/media/dnd_icon.8f794b71.svg";